import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import { ROUTES, STATES } from '../../../lib/routes'

/**
 * =======================================
 * ROUTES CONFIG - SETTINGS
 * =======================================
 *
 * @module webregister.routes.settings
 */
function SettingsRoutesConfig($stateProvider: StateProvider) {
  const reactQuickKeysTemplate = '<quick-keys-settings></quick-keys-settings>'

  const reactSettingsTemplate = '<settings></settings>'

  $stateProvider
    .state(STATES.SETTINGS, {
      url: ROUTES.SETTINGS,
      template: reactSettingsTemplate,
    })

    .state(STATES.SETTINGS_QUICK_KEYS, {
      url: '/quickkeys',
      abstract: true,
    })

    .state(STATES.SETTINGS_QUICK_KEYS_EDIT, {
      url: '/:layoutId',
      params: {
        newLayout: false,
      },
      views: {
        '@webregister': {
          template: reactQuickKeysTemplate,
        },
      },
    })
}

angular.module('webregister.routes').config(SettingsRoutesConfig)
